import React, { useState } from 'react';
import { List, useTable, EditButton, CreateButton } from '@refinedev/antd';
import { Table, Space, Tag, Select } from 'antd';

const POOL_CATEGORIES = ['DIET', 'EXERCISE', 'WATER', 'CHECK_IN'];

interface GamificationTaskRow {
  id: string;
  title: string;
  triggerEvent: string;
  targetValue: number;
  rewardCoins: number;
  rewardXp: number;
  poolCategory: string;
  difficulty: string;
  weight: number;
  isActive: boolean;
  sortOrder: number;
}

export const GamificationTaskList: React.FC = () => {
  const [poolFilter, setPoolFilter] = useState<string | undefined>();

  const { tableProps } = useTable<GamificationTaskRow>({
    resource: 'gamification-tasks',
    filters: {
      permanent: poolFilter
        ? [{ field: 'poolCategory', operator: 'eq' as const, value: poolFilter }]
        : [],
    },
    pagination: { current: 1, pageSize: 20 },
    queryOptions: { keepPreviousData: true },
  });

  return (
    <List
      title="Daily Task Pool"
      headerButtons={<CreateButton />}
    >
      <Space wrap style={{ marginBottom: 16 }}>
        <Select
          placeholder="Pool category"
          allowClear
          style={{ width: 200 }}
          value={poolFilter}
          onChange={setPoolFilter}
          options={POOL_CATEGORIES.map((c) => ({ value: c, label: c }))}
        />
      </Space>

      <Table {...tableProps} rowKey="id" scroll={{ x: 1100 }}>
        <Table.Column title="Title" dataIndex="title" width={200} />
        <Table.Column title="Pool" dataIndex="poolCategory" width={110} />
        <Table.Column title="Trigger" dataIndex="triggerEvent" width={160} />
        <Table.Column title="Target" dataIndex="targetValue" width={80} />
        <Table.Column title="Coins" dataIndex="rewardCoins" width={80} />
        <Table.Column title="XP" dataIndex="rewardXp" width={70} />
        <Table.Column title="Difficulty" dataIndex="difficulty" width={100} />
        <Table.Column title="Weight" dataIndex="weight" width={80} />
        <Table.Column title="Sort" dataIndex="sortOrder" width={70} />
        <Table.Column
          title="Active"
          dataIndex="isActive"
          width={80}
          render={(v: boolean) => (
            <Tag color={v ? 'green' : 'default'}>{v ? 'Yes' : 'No'}</Tag>
          )}
        />
        <Table.Column
          title="Actions"
          width={100}
          render={(_: unknown, row: GamificationTaskRow) => (
            <EditButton hideText size="small" recordItemId={row.id} />
          )}
        />
      </Table>
    </List>
  );
};
